//React modules that we installed via node modules
import React from "react";

//Components that we wrote ourselves
import WelcomeScreen from "./WelcomeScreen/WelcomeScreen.js";

//Styling main file
import "../styles/styles.scss";

import LevelOne from "./LevelOne/LevelOne.js";

//Import JS-file which ONLY contains function which returns an array
import coordinates from "./LevelOne/Data/coordinatedata.js";

//Node package that resets all default settings for browsers and makes it so that we know that it looks simialir no matter the browser the user uses
import "normalize.css/normalize.css";

import ErrorScreen from "./WelcomeScreen/ErrorScreen.js";

import Highscoretable from "./Highscore/Highscoretable.js";

//Facebook Sign in
import firebase from "firebase";
import { auth, provider } from "./firebase.js";

//App is our top (main) file that will contain most of our logic (functions) and will call on all components. App is is displayed in the index.js file
export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: undefined,
      username_full_name: undefined,
      level: undefined,
      totalScore: 0,
      continueEndScreen: false,
      continueWelcomeLevelTwo: false, // state to go to the modal WelcomeLevelTwo
      continueQuizModal: false, //state to show ModalQuiz in round 2 and three
      continueNextRound: false,
      whichModal: "one", // state to hold which modal should show when close a modal
      whichRound: undefined,
      distanceCountry: undefined,
      countryOne: undefined,
      countryTwo: undefined,
      cityOne: undefined,
      cityTwo: undefined,

      currentCoordinates: {
        continent: undefined,
        country: undefined,
        city: undefined,
        lat: undefined,
        lng: undefined,

        highScoreFirebase: undefined,
        username_full_name: undefined,
        login_on_going: false
      },
      profilePictureUrl: "",
      avatar: "Koala"
    };
  }

  pickAvatar = avatar => {
    localStorage.setItem("avatar", avatar);
  };

  handleNameSubmit = event => {
    event.preventDefault(); //Prevents HTML default behaviour to reload entire page when submitting form
    const inputtedName = event.target.elements.nameInput.value.trim(); //Take the value currently in the HTML input field with the name "nameInput". trim() removes unncessary whitespaces before and after input
    // eslint-disable-next-line
    if (inputtedName != 0) {
      this.setState({
        //Change the global state username using Reacts built in setState method(must be done with setState in React)
        username: inputtedName,
        level: "1"
      });
    } else {
      this.setState({
        //Change the global state username using Reacts built in setState method(must be done with setState in React)
        username: undefined,
        level: "error"
      });
    }
    localStorage.setItem("username", inputtedName);
  };

  changeModal = () => {
    this.setState({ whichModal: "two" });
  };

  compare = item => {
    let longName = this.state.currentCoordinates.continent;
    let shortName = item;

    if (longName === shortName) {
      this.updateScore(1000);
      return true;
    } else {
      return false;
    }
  };

  // Function return centrum coordinates of country
  getCoordinate = inputCountry => {
    var data = require("../components/LevelOne/Data/countriesCoordinates.json");
    let coordinate;
    for (var i = 0; i < data.length; i++) {
      var obj = data[i];

      if (obj.name === inputCountry) {
        coordinate = obj.latlng;
      }
    }
    return coordinate;
  };

  // //This code is inspired by the source: https://stackoverflow.com/questions/45958155/near-location-with-lat-and-long

  // Is called from distanceBetweenCoordinates
  deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  // Function calculate distance between coordinates
  distanceBetweenCoordinates = (c1, c2) => {
    let lat1 = c1[0];
    let lon1 = c1[1];
    let lat2 = c2[0];
    let lon2 = c2[1];

    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    d = Math.round(d);
    this.setState({ distanceCountry: d });
    return d;
  };

  //End of inspired code

  compareCountry = item => {
    let longName = this.state.currentCoordinates.country;
    let shortName = item;

    if (longName === shortName) {
      this.updateScore(1000);
      return true;
    } else {
      // Calls functions to calculate distance between two countries
      let coordinateOne = this.getCoordinate(longName);
      let coordinateTwo = this.getCoordinate(shortName);
      let distance = this.distanceBetweenCoordinates(
        coordinateOne,
        coordinateTwo
      );

      // Updates score for countries
      this.updateScore(Math.round(300 - distance / 33));

      return false;
    }
  };

  // goToWelcomeLevelTwo is called from ScoreBoard Level One when press the button Next Level
  goToWelcomeLevelTwo = () => {
    if (this.state.whichRound === 1) {
      this.setState({
        continueWelcomeLevelTwo: true,
        level: "2"
      });
    } else {
      this.setState({
        continueQuizModal: true
      });
    }
  };

  //goToEndScrren is called from ScoreBoard Level One when pressing button "End Game"
  goToEndScreen = () => {
    // localStorage.removeItem("username");
    // localStorage.removeItem("totalscore");
    // localStorage.removeItem("whichRound");

    this.setState({
      continueEndScreen: true,
      level: "endScreen"
    });
  };

  //goRestart is called from EndGameScreen when pressing button "Start New Game"
  //all the variable are reset to undefined
  goRestart = () => {
    this.setState({
      username: undefined,
      username_full_name: undefined,
      level: undefined,
      totalScore: 0,
      continueEndScreen: false,
      continueWelcomeLevelTwo: false, // state to go to the modal WelcomeLevelTwo
      continueQuizModal: false,
      distanceCountry: undefined,
      countryOne: undefined,
      countryTwo: undefined,
      cityOne: undefined,
      cityTwo: undefined,
      currentCoordinates: {
        continent: undefined,
        country: undefined,
        city: undefined,
        lat: undefined,
        lng: undefined
      },
      profilePictureUrl: "",
      firebaseStoredPlaces: {},
      avatar: "Koala"
    });
    localStorage.clear();
    window.location.reload(true);
  };

  updateScore = points => {
    if (localStorage.hasOwnProperty("totalscore")) {
      this.setState({
        totalScore: parseInt(localStorage.getItem("totalscore"), 10) + points
      });
      localStorage.setItem(
        "totalscore",
        parseInt(localStorage.getItem("totalscore"), 10) + points
      );

      this.writePointsToFirebase(
        this.state.username,
        parseInt(localStorage.getItem("totalscore"), 10),
        this.state.profilePictureUrl,
        this.state.currentCoordinates
      );
    } else {
      this.setState({
        totalScore: points
      });
      localStorage.setItem("totalscore", points);

      this.writePointsToFirebase(
        this.state.username,
        points,
        this.state.profilePictureUrl,
        this.state.currentCoordinates
      );
    }
  };

  //componentDidMount is a built-in React function which runs when the parent component (in this case App.js) is instanciated.
  //In this componentDidMount method we load a random object(our location) and then extract that locations latitude and longitude. We then update Apps state currentCord with those variables (latRandom, lngRandom).
  componentDidMount() {
    
    if (this.state.totalScore === undefined) {
      localStorage.setItem("totalscore", 0);
    }
    if (localStorage.hasOwnProperty("totalscore")) {
      this.setState({
        totalScore: parseInt(localStorage.getItem("totalscore"), 10)
      });
    }

    if (localStorage.hasOwnProperty("profilePictureUrl")) {
      this.setState({
        profilePictureUrl: localStorage.getItem("profilePictureUrl")
      });
    }
    if (localStorage.hasOwnProperty("whichRound")) {
      this.setState({
        whichRound: parseInt(localStorage.getItem("whichRound"), 10)
      });
    } else {
      this.setState({ whichRound: 1 });
      localStorage.setItem("whichRound", 1);
    }
    if (localStorage.hasOwnProperty("username")) {
      this.setState({ username: localStorage.getItem("username") });
    }

    if (localStorage.hasOwnProperty("whichModal")) {
      this.setState({
        whichModal: localStorage.getItem("whichModal")
      });
    }

    if (localStorage.getItem("continueQuizOne") === "true") {
      this.setState({
        continueQuizOne: true
      });
    }

    //Since the coordinates function returns an array of objects with key-value pairs within every object, this is how we reach each value (ex.lat, long) based on its key(number,number)

    let latRandom;
    let lngRandom;
    let randomNumber;

    // Here we check if user already has a location for current round. If so we don't generate a new one.
    if (localStorage.getItem("latLong") === null) {
      randomNumber = Math.floor(Math.random() * coordinates().length);

      latRandom = coordinates()[randomNumber].lat;
      lngRandom = coordinates()[randomNumber].long;
      let location = { latRandom, lngRandom, randomNumber };

      localStorage.setItem("latLong", JSON.stringify(location));
    } else {
      latRandom = JSON.parse(localStorage.getItem("latLong")).latRandom;
      lngRandom = JSON.parse(localStorage.getItem("latLong")).lngRandom;
      randomNumber = JSON.parse(localStorage.getItem("latLong")).randomNumber;
    }

    let continent = coordinates()[randomNumber].continent;
    let country = coordinates()[randomNumber].country;
    let city = coordinates()[randomNumber].city;

    // Added all propeties from coordinatedata.js to the set state as well as above when current coordinates is initiated
    this.setState({
      currentCoordinates: {
        continent: continent,
        country: country,
        city: city,
        lat: latRandom,
        lng: lngRandom
      }
    });

    // UPDATING TOTAL SCORE TO FIREBASE

    if (localStorage.hasOwnProperty("totalscore")) {
      this.writePointsToFirebase(
        localStorage.getItem("username"),
        parseInt(localStorage.getItem("totalscore")),
        this.state.profilePictureUrl
      );
    } else {
      this.writePointsToFirebase(
        localStorage.getItem("username"),
        this.state.totalScore,
        this.state.profilePictureUrl
      );
    }

    // This code is for importing firebase database and store it in a state called firebaseUSerna.
  }

  writePointsToFirebase(username, points, profilePictureUrl) {
    let name;
    if (localStorage.hasOwnProperty("username_full_name")) {
      name = localStorage.getItem("username_full_name");
    } else {
      name = username;
    }

    if (this.state.whichRound === 1) {
      localStorage.setItem("countryOne", this.state.currentCoordinates.country);
      localStorage.setItem("countryTwo", "-");
      localStorage.setItem("countryThree", "-");

      if (name !== null && name !== undefined && name !== "null" && name !== "" && name !== "undefined") {
        try {
          firebase
            .database()
            .ref("username/" + name)
            .set({
              points: points,
              profilePictureUrl: profilePictureUrl,
              countryOne: this.state.currentCoordinates.country,
              countryTwo: "-",
              countryThree: "-",
              avatar: localStorage.getItem("avatar")
            });
        } catch (error) {
          console.log({
            "Exception (probably from undefined value sent to Firebase)": error
          });
        }
      }
    } else if (this.state.whichRound === 2) {
      localStorage.setItem("countryTwo", this.state.currentCoordinates.country);
      if (name !== null && name !== undefined && name !== "null") {
        try {
          firebase
            .database()
            .ref("username/" + name)
            .set({
              points: points,
              profilePictureUrl: profilePictureUrl,
              countryOne: localStorage.getItem("countryOne"),
              countryTwo: this.state.currentCoordinates.country,
              countryThree: "-",
              avatar: localStorage.getItem("avatar")
            });
        } catch (error) {
          console.log({
            "Exception (probably from undefined value sent to Firebase)": error
          });
        }
      }
    } else if (this.state.whichRound === 3) {
      localStorage.setItem(
        "countryThree",
        this.state.currentCoordinates.country
      );

      if (name !== null && name !== undefined && name !== "null") {
        try {
          firebase
            .database()
            .ref("username/" + name)
            .set({
              points: points,
              profilePictureUrl: profilePictureUrl,
              countryOne: localStorage.getItem("countryOne"),
              countryTwo: localStorage.getItem("countryTwo"),
              countryThree: this.state.currentCoordinates.country,
              avatar: localStorage.getItem("avatar")
            });
        } catch (error) {
          console.log({
            "Exception (probably from undefined value sent to Firebase)": error
          });
        }
      }
    }
  }

  //goToNextRound is called from ScoreBoardLevelTwo to continue to a next round
  goToNextRound = () => {
    // Here we remove latLong so user gets new location.
    localStorage.removeItem("latLong");
    localStorage.removeItem("whichModal");
    localStorage.removeItem("continueQuizOne");
    localStorage.removeItem("continueScoreBoard");
    localStorage.removeItem("answered");
    localStorage.removeItem("ansone");
    localStorage.removeItem("anstwo");
    localStorage.removeItem("questionsFromAPI");

    if (localStorage.hasOwnProperty("whichRound")) {
      this.setState({
        continueNextRound: true,
        whichRound: parseInt(localStorage.getItem("whichRound"), 10) + 1,

        //reset state to next round
        level: "1",
        whichModal: "one",
        continueEndScreen: false,
        continueWelcomeLevelTwo: false
      });

      localStorage.setItem(
        "whichRound",
        parseInt(localStorage.getItem("whichRound"), 10) + 1
      );
    } else {
      this.setState({
        continueNextRound: true,
        whichRound: this.state.whichRound + 1,

        //reset state to next round
        level: "1",
        whichModal: "one",
        continueEndScreen: false,
        continueWelcomeLevelTwo: false
      });

      localStorage.setItem("whichRound", this.state.whichRound + 1);
    }

    window.location.reload();
    this.setState({
      avatar: localStorage.getItem("avatar")
    });
  };

  usernameAlreadyExists() {
    if (localStorage.hasOwnProperty("username")) {
      this.setState({ level: "1" });
    } else {
      return (
        <WelcomeScreen
          login={this.login}
          handleNameSubmit={this.handleNameSubmit}
          updateScore={this.updateScore}
          avatar={this.state.avatar}
          pickAvatar={this.pickAvatar}
        />
      );
    }
  }

  login = () => {
    auth()
      .signInWithPopup(provider)
      .then(({ user }) => {
        let wholeName = user.displayName.split(" ");
        this.setState({
          username_full_name: user.displayName,
          username: wholeName[0],
          level: "1",
          profilePictureUrl: user.photoURL
        });

        localStorage.setItem("username", wholeName[0]);
        localStorage.setItem("username_full_name", user.displayName);
        localStorage.setItem("profilePictureUrl", user.photoURL);
      });
  };

  render() {
    return (
      <div>
        <div class="Printout">
          {this.state.level === "1" ? (
            <div>
              <LevelOne
                username={this.state.username}
                totalScore={this.state.totalScore}
                level={this.state.level}
                currentCoordinates={this.state.currentCoordinates}
                compare={this.compare}
                compareCountry={this.compareCountry}
                goToWelcomeLevelTwo={this.goToWelcomeLevelTwo}
                continueWelcomeLevelTwo={this.state.continueWelcomeLevelTwo}
                goToEndScreen={this.goToEndScreen}
                continueEndScreen={this.state.continueEndScreen}
                goToNextRound={this.goToNextRound}
                changeModal={this.changeModal}
                whichModal={this.state.whichModal}
                continueNextRound={this.state.continueNextRound}
                whichRound={this.state.whichRound}
                updateScore={this.updateScore}
                continueQuizModal={this.state.continueQuizModal}
                distanceCountry={this.state.distanceCountry}
                avatar={this.state.avatar}
              />
            </div>
          ) : this.state.level === "2" ? (
            <div>
              <LevelOne
                username={this.state.username}
                totalScore={this.state.totalScore}
                level={this.state.level}
                currentCoordinates={this.state.currentCoordinates}
                compare={this.compare}
                compareCountry={this.compareCountry}
                goToWelcomeLevelTwo={this.goToWelcomeLevelTwo}
                continueWelcomeLevelTwo={this.state.continueWelcomeLevelTwo}
                goToEndScreen={this.goToEndScreen}
                continueEndScreen={this.state.continueEndScreen}
                goToNextRound={this.goToNextRound}
                changeModal={this.changeModal}
                whichModal={this.state.whichModal}
                continueNextRound={this.state.continueNextRound}
                whichRound={this.state.whichRound}
                updateScore={this.updateScore}
                continueQuizModal={this.state.continueQuizModal}
                distanceCountry={this.state.distanceCountry}
                avatar={this.state.avatar}
              />
            </div>
          ) : this.state.level === "error" ? (
            <div>
              <ErrorScreen
                handleNameSubmit={this.handleNameSubmit}
                login={this.login}
                pickAvatar={this.pickAvatar}
              />
            </div>
          ) : this.state.level === "endScreen" ? (
            <Highscoretable
              goRestart={this.goRestart}
              username={this.state.username}
              username_full_name={this.username_full_name}
              totalScore={this.state.totalScore}
              profilePictureUrl={this.state.profilePictureUrl}
              currentCoordinates={this.state.currentCoordinates}
              avatar={this.state.avatar}
            />
          ) : (
            this.usernameAlreadyExists()
          )}
        </div>
      </div>
    );
  }
}
